define('customPlugins/injectAfterkeydownBinding',['knockout'],
    function(ko) {
        var getInjectValueUpdate = function(allBindings) {
            return {
                has: function(bindingKey) {
                    return (bindingKey == 'valueUpdate') || allBindings.has(bindingKey);
                },
                get: function(bindingKey) {
                    var binding = allBindings.get(bindingKey);
                    if (bindingKey == 'valueUpdate') {
                        binding = binding ? [].concat(binding, 'afterkeydown') : 'afterkeydown';
                    }
                    return binding;
                }
            };
        };

        var valueInitHandler = ko.bindingHandlers.value.init;
        ko.bindingHandlers.value.init = function(element, valueAccessor, allBindings, viewModel, bindingContext) {
            return valueInitHandler(element, valueAccessor, getInjectValueUpdate(allBindings), viewModel, bindingContext);
        };
    });
